import React from 'react';
import { NumericFormat, InputAttributes } from 'react-number-format';

export interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export default React.forwardRef<React.ElementRef<typeof NumericFormat>, CustomProps>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      decimalScale={2}
      valueIsNumericString={true}
    />
  );
});
